import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Button, Input, Space, Table, Tag, message } from "antd";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { axiosInstance } from "../utils/api";

const SaleQuantity = () => {
  const { id } = useParams();
  const [searchSku, setSearchSku] = useState("");
  const queryClient = useQueryClient();

  const { data: saleProducts, isLoading } = useQuery({
    queryKey: ["saleProducts", id],
    queryFn: async () => {
      const res = await axiosInstance.get(`/admin/sale/${id}`);
      return res.data;
    },
  });

  const updateMutation = useMutation({
    mutationFn: async (products) => {
      const res = await axiosInstance.put(`/admin/sale/${id}`, {
        ...saleProducts,
        productsQuantity: products,
      });
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["saleProducts", id]);
      message.success("Products updated successfully");
    },
  });

  const searchProduct = async () => {
    try {
      const res = await axiosInstance.post("/admin/quantity-sku", {
        sku: searchSku,
      });
      const newProducts = [...(saleProducts?.productsQuantity || []), res.data];
      updateMutation.mutate(newProducts);
      setSearchSku("");
    } catch (error) {
      message.error("Product not found");
    }
  };

  const handleRemoveProduct = (productId) => {
    const newProducts = saleProducts.productsQuantity.filter(
      (p) => p._id !== productId
    );
    updateMutation.mutate(newProducts);
  };

  const columns = [
    {
      title: "SKU",
      dataIndex: "sku",
      render: (sku) => <Tag color="blue">{sku}</Tag>,
    },
    { title: "Name", dataIndex: ["product", "name"] },
    { title: "Price", dataIndex: "price" },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Button
          type="link"
          danger
          onClick={() => handleRemoveProduct(record._id)}
        >
          Remove
        </Button>
      ),
    },
  ];

  return (
    <Space direction="vertical" className="w-full p-6">
      <Space className="w-full mb-4">
        <Input
          placeholder="Search by SKU"
          value={searchSku}
          onChange={(e) => setSearchSku(e.target.value)}
        />
        <Button type="primary" onClick={searchProduct}>
          Add Product
        </Button>
      </Space>

      <Table
        columns={columns}
        dataSource={saleProducts?.productsQuantity}
        loading={isLoading}
        rowKey="_id"
      />
    </Space>
  );
};

export default SaleQuantity;
